// Kontaktformular: Betreff aus einem Link vorbelegen, z. B. /?betreff=Impressum%20%26%20Datenschutz#kontakt (Version 2.74)
(function () {
  function setzen(b, immer) {
    var f = document.getElementById('kf-betreff');
    if (!f || !b || (f.value && !immer)) return;
    if (window.NadosI18n && NadosI18n.get && NadosI18n.get() === 'en' && NadosI18n.t) b = NadosI18n.t(b);
    f.value = String(b).slice(0, 120);
    if (window.NadosBetreff) window.NadosBetreff.sperren();
  }
  function ausAdresse() {
    try { setzen(new URLSearchParams(location.search).get('betreff') || '', false); } catch (e) {}
  }
  // Klick auf einen solchen Link auf derselben Seite: ohne Neuladen zum Formular
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="betreff="]');
    if (!a || e.ctrlKey || e.metaKey || e.shiftKey) return;
    var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
    if (u.origin !== location.origin || u.pathname !== location.pathname || u.hash !== '#kontakt') return;
    var b = u.searchParams.get('betreff'); if (!b) return;
    e.preventDefault();
    setzen(b, true);
    if (location.hash !== '#kontakt') location.hash = 'kontakt';
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ausAdresse); else ausAdresse();
  document.addEventListener('shopify:section:load', ausAdresse);
})();

// Datenschutz Abschnitt 4: Link „Cookie-Einstellungen öffnen“ (#reopenBanner) öffnet das Banner von Pandectes GDPR (Version 2.80)
(function () {
  window.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href*="#reopenBanner" i]') : null;
    if (!a) return;
    e.preventDefault();                       // kein Seitenwechsel durch das Hash-Routing des Themes
    if (a.onclick) return;                    // Pandectes hat den Link selbst übernommen (Einstellung „Custom Trigger“)
    var host = document.querySelector('pandectes-cmp');
    var knopf = host && host.shadowRoot ? host.shadowRoot.querySelector('button.widget') : null;
    if (knopf) knopf.click();                 // wie ein Klick auf das Cookie-Symbol: Banner öffnet sich erneut
  }, true);
})();

// Cookie-Banner (Pandectes): Lage und Farben passend zum Theme (Version 2.82)
(function () {
  var CSS = '.widget { color: #8A2BE2 !important; background-color: #FBF7F0 !important; border: 1.5px solid #e6dccb; }' +
    ' dialog.dialog { border: 1px solid #e6dccb; }' +
    ' dialog button.primary, dialog button.secondary { background: #faf5ff !important; color: #3d1a45 !important; border: 1px solid #8A2BE2 !important;' +
    '   border-radius: 14px !important; box-shadow: 0 6px 18px rgba(138, 43, 226, 0.10) !important; font-family: Poppins, sans-serif !important; font-weight: 600 !important;' +
    '   transition: background .18s ease, color .18s ease, border-color .18s ease; }' +
    ' dialog button.primary:active, dialog button.secondary:active { background: #8A2BE2 !important; color: #ffffff !important; }' +
    ' @media (hover: hover) { dialog button.primary:hover, dialog button.secondary:hover { background: #8A2BE2 !important; color: #ffffff !important; } }' +
    ' @media (max-width: 1000px) {' +                 // untere Navigationsleiste des Themes freihalten
    '   .widget.bottom { bottom: calc(88px + env(safe-area-inset-bottom, 0px)) !important; }' +
    '   dialog.dialog.notice { bottom: calc(88px + env(safe-area-inset-bottom, 0px)) !important; }' +
    ' }' +
    ' @media (max-width: 760px) { dialog.dialog.notice { left: 12px !important; right: 12px !important; width: auto !important; max-width: none !important; } }';
  CSS += ' @media (max-width: 1000px) {' +
    '   :host(.nd-w-oben) .widget.bottom, :host(.nd-w-links) .widget.bottom { bottom: auto !important; top: calc(12px + env(safe-area-inset-top, 0px)) !important; left: 16px !important; right: auto !important; }' +
    ' }';
  function einsetzen() {
    var host = document.querySelector('pandectes-cmp');
    if (!host || !host.shadowRoot) return false;
    if (!host.shadowRoot.getElementById('nd-pandectes-stil')) {
      var st = document.createElement('style'); st.id = 'nd-pandectes-stil'; st.textContent = CSS;
      host.shadowRoot.appendChild(st);
    }
    return true;
  }
  var n = 0;
  (function warten() { if (einsetzen() || ++n > 80) return; setTimeout(warten, 250); })();
})();

// Kontaktformular: vorausgewählter Betreff (Catering-Paket, Catering-Anfrage, Impressum & Datenschutz) ist gesperrt,
// direkt über „Kontakt“ aufgerufen ist der Betreff frei (Version 2.85)
(function () {
  var stil = document.createElement('style');
  stil.textContent = '#kf-betreff.nd-betreff-fest { background: #faf5ff !important; border-color: #8A2BE2 !important; color: #3d1a45; cursor: default; }' +
    ' #kf-betreff.nd-betreff-fest:focus { box-shadow: none; }';
  document.head.appendChild(stil);
  function feld() { return document.getElementById('kf-betreff'); }
  function sperren() {
    var f = feld(); if (!f || !f.value) return;
    f.readOnly = true; f.setAttribute('aria-readonly', 'true'); f.classList.add('nd-betreff-fest');
  }
  function freigeben(leeren) {
    var f = feld(); if (!f) return;
    var war = f.classList.contains('nd-betreff-fest');
    f.readOnly = false; f.removeAttribute('aria-readonly'); f.classList.remove('nd-betreff-fest');
    if (leeren && war) f.value = '';
    if (f.form) f.form.removeAttribute('data-catering'); // wieder normale Kontaktnachricht
  }
  window.NadosBetreff = { sperren: sperren, freigeben: freigeben };
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null; if (!t) return;
    // Catering-Knöpfe setzen den Betreff selbst (nados-7.js) – danach sperren
    if (t.closest('.cta-catering-paket, #cta-catering-anfragen')) { setTimeout(sperren, 0); return; }
    // normaler Weg zur Kontaktseite (Menü, Fußzeile …): Betreff wieder frei und leer
    var a = t.closest('a[href*="#kontakt"]');
    if (a && (a.getAttribute('href') || '').indexOf('betreff=') === -1) freigeben(true);
  }, true);
  document.addEventListener('reset', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('#kf-betreff')) freigeben(false); }, true);
  function start() {
    var b = ''; try { b = new URLSearchParams(location.search).get('betreff') || ''; } catch (x) {}
    if (b) setTimeout(sperren, 0);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

// Mobil: Widgets (Cookie, Barrierefreiheit) weichen geoeffneten Fenstern aus (Version 2.90)
(function () {
  var html = document.documentElement, alt = '';
  function sichtbar(sel) { var n = document.querySelector(sel); return !!n; }
  function pruefen() {
    var art = '';
    if (document.querySelector('.cart-drawer.open')) art = 'links';
    else if (html.classList.contains('box-open') || sichtbar('.box-modal:not([hidden])') || sichtbar('.nd-sorte-pop:not([hidden]):not(.is-hover)')) art = 'oben';
    if (art === alt) return;
    alt = art;
    html.classList.toggle('nd-w-oben', art === 'oben');
    html.classList.toggle('nd-w-links', art === 'links');
    var host = document.querySelector('pandectes-cmp');
    if (host) { host.classList.toggle('nd-w-oben', art === 'oben'); host.classList.toggle('nd-w-links', art === 'links'); }
  }
  var geplant = false;
  function bald() { if (geplant) return; geplant = true; setTimeout(function () { geplant = false; pruefen(); }, 30); }
  function start() {
    try { new MutationObserver(bald).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] }); } catch (e) {}
    pruefen();
    setInterval(function () { var h = document.querySelector('pandectes-cmp'); if (h && alt && !h.classList.contains('nd-w-' + alt)) { alt = ''; pruefen(); } }, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

// Warenkorb: Box-Namen immer deutsch speichern (Bestellung/Rechnung), Anzeige passend zur Sprache (Version 2.94)
(function () {
  function deName(n) {
    n = String(n || ''); var m;
    if ((m = /^Your selection of (\d+)$/.exec(n))) return 'Deine ' + m[1] + 'er Auswahl';
    if ((m = /^Your box of (\d+)$/.exec(n))) return 'Deine ' + m[1] + 'er Box';
    return n;
  }
  window.NadosDeName = deName;
  function einhaengen() {
    var c = window.NadosCart;
    if (!c || !c.addBox) return false;
    if (c.addBox.__ndDe) return true;
    var orig = c.addBox;
    c.addBox = function (b) { if (b && b.name) b.name = deName(b.name); return orig.apply(this, arguments); };
    c.addBox.__ndDe = true;
    return true;
  }
  function englisch() { return !!(window.NadosI18n && NadosI18n.get && NadosI18n.get() === 'en'); }
  function namenAnpassen() {
    einhaengen();
    var liste = document.querySelectorAll('#cart-drawer .cart-item-name > span:first-child');
    Array.prototype.forEach.call(liste, function (s) {
      var t = s.textContent.trim(), de = deName(t);
      if (de === t) return;                                  // schon deutsch oder unbekannt
      var ziel = englisch() ? t : de;
      if (ziel !== t) s.textContent = ziel;
    });
  }
  var geplant = false;
  function bald() { if (geplant) return; geplant = true; setTimeout(function () { geplant = false; namenAnpassen(); }, 40); }
  function start() {
    namenAnpassen();
    try { new MutationObserver(bald).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    var n = 0; (function warten() { if (einhaengen() || ++n > 80) return; setTimeout(warten, 250); })();
  }
  document.addEventListener('nados:lang', bald);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
